<div class="skeleton" aria-busy="true" aria-label="Loading your snapshot">
  <div class="skeleton__tiles">
    <ngx-skeleton-loader
      class="skeleton__tile"
      *ngFor="let tile of tiles; trackBy: trackByIndex"
      count="1"
      appearance="line"
      [theme]="tileTheme"
    ></ngx-skeleton-loader>
  </div>
  <ngx-skeleton-loader class="skeleton__hero" count="1" appearance="line" [theme]="heroTheme"></ngx-skeleton-loader>
  <ngx-skeleton-loader class="skeleton__list" count="5" appearance="line" [theme]="listTheme"></ngx-skeleton-loader>
</div>
